import {
  DASHBOARD_TOP_LOW_PERFORMERS,
  GET_DASHBOARD_LATE_COUNT,
  GET_DASHBOARD_PERFORMANCE, //new apis
  GET_DASHBOARD_STATUS,
  GET_DASHBOARD_TASK_PROGRESS,
  GET_DASHBOARD_TASK_SUMMARY,
  GET_DASHBOARD_TICKET_COUNT_BY_TYPE,
  GET_DASHBOARD_TICKET_RESPONSE_TIME_METRICS,
  GET_DASHBOARD_TICKET_RESPONSE_TIME_METRICS_FAILURE,
  GET_DASHBOARD_TICKET_RESPONSE_TIME_METRICS_SUCCESS,
  GET_DASHBOARD_TIME_METRICS,
  GET_DASHBOARD_USER_ANALYTICS,
} from '../../modules/constants';

// ------------------------------------
// Actions
// ------------------------------------

export function getDashboardStatus(value) {
  return {
    type: GET_DASHBOARD_STATUS,
    payload: value,
  };
}
export function getDashboardTaskProgress(value) {
  return {
    type: GET_DASHBOARD_TASK_PROGRESS,
    payload: value,
  };
}

export function getDashboardTaskSummary(value) {
  return {
    type: GET_DASHBOARD_TASK_SUMMARY,
    payload: value,
  };
}
export function getDashboardPerformance(value) {
  return {
    type: GET_DASHBOARD_PERFORMANCE,
    payload: value,
  };
}
export function getDashboardLateCount(value) {
  return {
    type: GET_DASHBOARD_LATE_COUNT,
    payload: value,
  };
}
export function getDashboardTopLowPerformers(value) {
  return {
    type: DASHBOARD_TOP_LOW_PERFORMERS,
    payload: value,
  };
}
export function getDashboardUserAnalytics(value) {
  return {
    type: GET_DASHBOARD_USER_ANALYTICS,
    payload: value,
  };
}

export function getDashboardTimeMetrics(value) {
  return {
    type: GET_DASHBOARD_TIME_METRICS,
    payload: value,
  };
}

export function getDashboardTicketCountByType(value) {
  return {
    type: GET_DASHBOARD_TICKET_COUNT_BY_TYPE,
    payload: value,
  };
}

export function getDashboardTicketResponseTimeMetrics(value) {
  return {
    type: GET_DASHBOARD_TICKET_RESPONSE_TIME_METRICS,
    payload: value,
  };
}

export function getDashboardTicketResponseTimeMetricsSuccess(value) {
  return {
    type: GET_DASHBOARD_TICKET_RESPONSE_TIME_METRICS_SUCCESS,
    payload: value,
  };
}

export function getDashboardTicketResponseTimeMetricsFailure(value) {
  return {
    type: GET_DASHBOARD_TICKET_RESPONSE_TIME_METRICS_FAILURE,
    payload: value,
  };
}
